module.exports = __webpack_public_path__ + "static/img/card.0bc7cd5.1763978124417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card.png
// module id = Pzc5
// module chunks = 69